<app-inbound-fax-header [inboundFax]="inboundFaxInitialState" />

<div class="mt-2">

  <div class="row">
    <div class="col-5">
      @if (!inboundFax.processed && !inOcrOrLlmProcessing) {
        <app-inbound-fax-process-form
          [inboundFax]="inboundFax"
          (inboundFaxAttributeChanged)="onInboundFaxAttributeChange($event)"
          [similarInboundFaxState]="similarInboundFaxState"
          (tabChangeRequested)="onTabChangeRequested($event)"
          (nextFaxRequested)="onNextFaxRequested()"
          (skipToNextFaxRequested)="onSkipToNextFaxRequested()"
          (navigateToQueueRequested)="onNavigateToQueueRequested()" />
      }

      @if (inOcrOrLlmProcessing) {
        <app-inbound-fax-view-ocr-llm-processing
          [inboundFax]="inboundFax"
          (navigateToQueueRequested)="onNavigateToQueueRequested()" />
      }

      @if (inboundFax.processed) {
        <app-inbound-fax-view-processed
          [inboundFax]="inboundFax"
          />
      }
    </div>
    <div class="col-7">
      <app-inbound-fax-possible-patients
        [inboundFax]="inboundFax" />

      @if (inboundFax.url) {
        <app-pdf-basic-viewer
          height="107.5vh"
          pdfKitViewerClass="card phi"
          pdfFileViewerClass="phi"
          [pdfFile]="inboundFax"
          [pdfFileType]="pdfFileType"
          [editable]="!inOcrOrLlmProcessing"
          (urlChange)="onPdfUrlChange($event)" />
      } @else {
        No PDF file is associated.
      }
    </div>
  </div>

</div>

